
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { AlertTriangleIcon } from "lucide-react";

interface PollErrorStateProps {
  error: Error | null;
}

const PollErrorState = ({ error }: PollErrorStateProps) => {
  return (
    <Alert variant="destructive" className="mb-6">
      <AlertTriangleIcon className="h-4 w-4" />
      <AlertTitle>Error</AlertTitle>
      <AlertDescription>
        {error ? `Failed to load poll: ${error.message}` : "Poll not found"}
      </AlertDescription>
    </Alert>
  );
};

export default PollErrorState;
